import { HrefBehavior } from "@finbackoffice/enums";
import { useCallback } from "react";

export const useHrefBehavior = () => {
    const isGame = useCallback(
        (href_behavior: HrefBehavior) =>
            [HrefBehavior.GameSlot, HrefBehavior.GameLiveCasino].includes(href_behavior),
        [],
    );

    const isLink = useCallback(
        (href_behavior: HrefBehavior) =>
            [HrefBehavior.External, HrefBehavior.Relative].includes(href_behavior),
        [],
    );

    const isSlots = useCallback(
        (href_behavior: HrefBehavior) => href_behavior === HrefBehavior.GameSlot,
        [],
    );

    return { isGame, isLink, isSlots };
};
